/** Close the expanded Firefly panel, then run a navigation / CTA callback. */
export function closeDockThen<A extends unknown[]>(
  setOpen: (open: boolean) => void,
  fn: (...args: A) => void,
): (...args: A) => void;
export function closeDockThen<A extends unknown[]>(
  setOpen: (open: boolean) => void,
  fn?: (...args: A) => void,
): ((...args: A) => void) | undefined;
export function closeDockThen<A extends unknown[]>(
  setOpen: (open: boolean) => void,
  fn?: (...args: A) => void,
): ((...args: A) => void) | undefined {
  if (!fn) return undefined;
  return (...args: A) => {
    setOpen(false);
    fn(...args);
  };
}
